/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlimited_PausesInputs */

const en_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause anytime`)
};

const ar_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إيقاف مؤقت في أي وقت`)
};

const de_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jederzeit pausieren`)
};

const es_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausa cuando quieras`)
};

const fr_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause à tout moment`)
};

const it_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metti in pausa quando vuoi`)
};

const ja_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつでも一時停止`)
};

const ko_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언제든지 일시 정지`)
};

const pt_br_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause quando quiser`)
};

const ru_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пауза в любое время`)
};

const th_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หยุดพักได้ทุกเมื่อ`)
};

const tr_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstediğin zaman duraklat`)
};

const zh_cn_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随时暂停`)
};

const zh_tw_unlimited_pauses = /** @type {(inputs: Unlimited_PausesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隨時暫停`)
};

/**
* | output |
* | --- |
* | "Pause anytime" |
*
* @param {Unlimited_PausesInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const unlimited_pauses = /** @type {((inputs?: Unlimited_PausesInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlimited_PausesInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlimited_pauses(inputs)
	if (locale === "ar") return ar_unlimited_pauses(inputs)
	if (locale === "de") return de_unlimited_pauses(inputs)
	if (locale === "es") return es_unlimited_pauses(inputs)
	if (locale === "fr") return fr_unlimited_pauses(inputs)
	if (locale === "it") return it_unlimited_pauses(inputs)
	if (locale === "ja") return ja_unlimited_pauses(inputs)
	if (locale === "ko") return ko_unlimited_pauses(inputs)
	if (locale === "pt_br") return pt_br_unlimited_pauses(inputs)
	if (locale === "ru") return ru_unlimited_pauses(inputs)
	if (locale === "th") return th_unlimited_pauses(inputs)
	if (locale === "tr") return tr_unlimited_pauses(inputs)
	if (locale === "zh_cn") return zh_cn_unlimited_pauses(inputs)
	return zh_tw_unlimited_pauses(inputs)
});